<template>
  <div class="Page SchematicChart">
    <div class="Page-Content" style="display: flex;flex-direction: row;">

    <div class="building-tab-bar">
      <div style="font-size: 1.5rem;font-weight: 500;">Schematic Chart</div>
      <div class="col" style="width: calc(100% - 10px);height: 65vh;overflow: auto; justify-content: flex-start;padding-right: 10px;">
        <div class="building-btn-group" 
        @click="select_ck_index = i" 
        v-for="(data,i) in select_data" 
        :key="i">
          <div style="background-color: black;height: 2px;width: 100%;"></div>
          <div class="btns row" style="justify-content: space-between;font-weight: 600;" @click="select_data[i].isShow = !select_data[i].isShow">
            <span style="max-width: 90%;">{{data.tabName}}</span>
            <div v-if="data.isShow" class="select-btns" ></div>
            <div v-else class="select-btns" style="background-color: white;border: 1px solid #000;"></div>

          </div>
          <!-- <div v-if="select_data_ck[i] != 'All' && select_ck_index != i" class="building-btn click-min-btn" style="font-size: 10px;"> {{ select_data_ck[i] != 'All' ? `${select_data_ck[i]}` : "" }}</div> -->
          <div v-if="data.isShow">
            <div class="btn-info-line row" 
              v-for="(types,j) in data.tabData" 
              :key="j"
              :class="{'click-min-btn':select_data_ck[i] === types}"
              @click="filtrateUnit(types,i)"
              style="justify-content: flex-start;justify-content: space-between;"
              >
              <div>{{ types }}</div>
              <div v-if="types == select_data_ck[i]" class="clear-min" @click="select_data_ck[i] = '',filtrateUnit()" >Clear</div>

            </div>
          </div>
          </div>
          
          <div v-for="(data,i1) in select_data2" :key="i1" class="building-btn-group" >
            <div style="background-color: black;height: 2px;width: 100%;"></div>
            <div class="btns row" style="justify-content: space-between;font-weight: 600;"
              @click="filtrateUnit(i1,i1)"
              :class="{'click-min-btn':select_data_ck[i1]}"
              >
                {{data.tabName}}
              <div class="clear-min" @click="select_data_ck[i1] = '',filtrateUnit()" v-if="select_data_ck[i1]">Clear</div>

              </div>
          </div>
      </div>


      <!-- <div style="font-weight: 400;margin: 20px auto;background-color: black;border-radius: 20px;color: white;padding: 5px;width: 50%;text-align: center;" @click="ClearConditions"> Clear Filter </div> -->

    </div>
    <!-- <div class="building-tab-bar">
      <label>Unit Type</label>
      <select name="UnitType" v-model="UnitType" @change="handleSelectChange">
        <option value="All">All</option>
        <option value="E">E</option>
        <option value="BS">BS</option>
      </select>
    </div> -->
    <div style="width: 80%;overflow: auto;" v-if="showfloorplan == 'building'" class="BuildingData">
      <div class="BuildingShowDiv growFromScaleAnimation"  v-for="(building, a) in BuildingList" :key="a">
        <div style="margin-bottom: 1rem;color: black;font-weight: 600;text-align: center;width: 100%;">{{ building.title }}</div>
        <div class="table-data">
          <div
            class="table-tr"
            v-for="(data, tr) in building.buildingData"
            :key="tr"
            :class="{ mergetr: data.length == 2 }"
          >
            <div
              class="table-td"
              :style="`background-color:${tddata.color};`"
              :class="{'td-tab': td == 0,'td-tab-top': td != 0 && tr == 0, mergetd: td == 1 && data.length == 2}"
              @click="goUnit(tddata.unitname)"
              v-for="(tddata, td) in data"
              :key="td"
              v-if="tddata.show || tddata.type == 'tab' || tddata.type == 'Stacks'"
            >
              <span v-if="tr !=0 && td == 0">{{ tddata.name }}</span>
              <span v-else-if="tr == 0 && td != 0">{{ tddata.name }}</span>
              <span v-else-if="tr == 0 && td == 0">{{ tddata.name }}</span>
              <span v-else >{{ tddata.name }}</span>
            </div>
            <div v-else class="table-td" 
            :class="{'td-tab': td == 0,'td-tab-top': td != 0 && tr == 0, mergetd: td == 1 && data.length == 2}"
            ></div>
          </div>
        </div>
      </div>
      <!-- <div class="BuildingList flex-contents">
        <div
          class="BuildingListBtn"
          @click="clickBuilding(item, i)"
          :class="{ checkedBuildingBtn: buildingName == i }"
          v-for="(item, i) in BuildingList"
          :key="i"
        >
          {{ i }}
        </div>
      </div> -->
    </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      select_ck_index:"",
      select_data_ck:{
        Price:"",
        Bedrooms:"",
        Bathrooms:"",
        Area:"",
        Orientation:"",
        View:"",
        Kitchen:"",
        Study:"",
        Lift:"",
        Yard:"",
      },
      select_data:{
        // Price:{
        //   tabName:"Price",
        //   tabData:[
        //     "All",
        //     "< SGD1,499,999",
        //     "SGD1,500,000 – SGD1,999,999",
        //     "SGD2,000,000 - SGD2,499,999",
        //     "SGD2,500,000 – SGD2,999,999",
        //     "SGD3,000,000 – SGD3,499,999",
        //     "SGD3,500,000 – SGD3,999,999",
        //     "SGD4,000,000 and above",
        //   ]
        // },
        Bedrooms:{
          tabName:"No. of Bedrooms",
          isShow:false,
          tabData:["2 Bedrooms","3 Bedrooms","4 Bedrooms","5 Bedrooms",]
        },
        Bathrooms:{
          isShow:false,
          tabName:"No. of Bathrooms (including WC and powder room)",
          tabData:["1 Bathrooms","2 Bathrooms","3 Bathrooms","4 Bathrooms","6 Bathrooms",]
        },
        Area:{
          isShow:false,
          tabName:"Floor Area",
          tabData:[
          "< 699 sqft",
          "700 – 899 sqft",
          "900 – 1,099 sqft",
          "1,100 – 1,299 sqft",
          "1,300 – 1,499 sqft",
          "1,500 – 1,699 sqft",
          "1,700 sqft and above",
        ]
        
        },
        Orientation:{
          isShow:false,
          tabName:"Orientation (from living room balcony)",
          tabData:[
            "North",
            "South",
            "East",
            "West",
          ]

        },
        View:{
          isShow:false,
          tabName:"View (from living room balcony)",
          tabData:[
            "Clementi Nature Trail / Police KINS Training Camp",
            "Infinity Edge Wellness Pool",
            "Lagoon Pool",
            "Children’s Pool",
            "Water Cascade",
          ]
        },

      },
      select_data2:{
        Kitchen:{
          isShow:false,
          tabName:"Kitchen",
          tabData:["Need"]
        },
        Study:{
          isShow:false,
          tabName:"Study",
          tabData:["Need"]
        },
        Lift:{
          isShow:false,
          tabName:"Private Lift",
          tabData:["Need"]
        },
        Yard:{
          isShow:false,
          tabName:"Yard",
          tabData:["Need"]
        },
      },
      nowUnit:{},
      // nowBuilding: [], // 当前楼栋数据
      buildingName: "BLOCK 72", // 当前楼栋名称
      showfloorplan:"building", // 当前所在模块
      // 楼栋列表
      BuildingList: this.$Datas.building,
      // 户型列表
      FloorplanData:this.$Datas.floorplan,
      UnitTypeLists:this.$Datas.unit_type_list,
      OrientationStacks:{
        North:['3', '4', '5', '6', '11', '12', '13', '17', '18', '23', '24'],
        South:['1', '2', '7', '8', '9', '10', '15', '16', '19', '20', '21', '22'],
        East:['14'],
        West:[],
      },
      ViewStacks:{
          "Clementi Nature Trail / Police KINS Training Camp":['3', '4', '5', '6', '11', '12', '13', '17', '18', '23', '24'],
          "Infinity Edge Wellness Pool":['11', '12', '13'],
          "Lagoon Pool":['3', '4', '5', '6', '14', '19', '20', '21', '22'],
          "Children’s Pool":['9', '10', '15', '16'],
          "Water Cascade":['1', '2', '6', '7']
        }
    };
  },
  methods: {


    ClearConditions(){
      // 重置筛选条件
      this.select_data_ck = {
        Price:"",
        Bedrooms:"",
        Bathrooms:"",
        Area:"",
        Orientation:"",
        View:"",
        Kitchen:"",
        Study:"",
        Lift:"",
        Yard:"",
      }
      this.filtrateUnit()
    },
    filtrateFloorPlan(){
      // 户型筛选
      const show_floorplan = []

      for (const unitKey in this.FloorplanData) {
        const floorplan = this.FloorplanData[unitKey];
        const F_Price =  (floorplan.Price == this.select_data_ck.Price || this.select_data_ck.Price == '') ? true :false; // 价格
        const F_Bedrooms =  (floorplan.Bedrooms == this.select_data_ck.Bedrooms || this.select_data_ck.Bedrooms == '') ? true :false; // 房间
        const F_Bathrooms =  (floorplan.Bathrooms == this.select_data_ck.Bathrooms || this.select_data_ck.Bathrooms == '') ? true :false; // 厕所
        const F_Area =  (floorplan.Area == this.select_data_ck.Area || this.select_data_ck.Area == '') ? true :false; // 面积
        const F_Kitchen =  (floorplan.Kitchen  || this.select_data_ck.Kitchen == '') ? true :false; // 厨房
        const F_Study =  (floorplan.Study == this.select_data_ck.Study || this.select_data_ck.Study == '') ? true :false; // 阳台
        const F_Lift =  (floorplan.Lift == this.select_data_ck.Lift || this.select_data_ck.Lift == '') ? true :false; // 价格
        const F_Yard =  (floorplan.Yard == this.select_data_ck.Yard || this.select_data_ck.Yard == '') ? true :false; // 价格

        // console.log(F_Price, F_Bedrooms, F_Bathrooms, F_Area, F_Kitchen, F_Study, F_Lift, F_Yard);
        
        if(F_Price && F_Bedrooms && F_Bathrooms && F_Area && F_Kitchen && F_Study && F_Lift && F_Yard){
          // 所有条件都满足的户型
          // console.log(unitKey);
          show_floorplan.push(unitKey)
        }

      }
      return show_floorplan;
    },

    filtrateUnit(types,click_1_index){
      event.stopPropagation()
      this.select_data_ck[click_1_index] = types // 记录当前选中条件
      console.log(this.select_data_ck);

      let show_floorplan = this.filtrateFloorPlan() // 获取符合条件户型

      for (const blockKey in this.BuildingList) {
        let Show_Stacks = []; // 符合条件单元列表下标记录
        const block = this.BuildingList[blockKey];
        block.buildingData.forEach((floor,index) => {
          if(index == 0){
            // 筛选单元下标
            floor.forEach((unit,index1) =>{
              const OrientationIndex = (this.select_data_ck.Orientation == '' || this.OrientationStacks[this.select_data_ck.Orientation].includes(unit.name)) ? index1 : false // 筛选单元
              const ViewIndex = (this.select_data_ck.View == '' || this.ViewStacks[this.select_data_ck.View].includes(unit.name)) ? index1 : false // 筛选单元
              if(OrientationIndex !== false && ViewIndex !== false){
                // console.log('-----符合单元下标',index1);
                Show_Stacks.push(index1)
              }
            })
            return;
          }
          floor.forEach((unit,index1) => {
              // 判断户型，单元是否符合条件
            if(show_floorplan.includes(unit.name) && Show_Stacks.includes(index1)) {
              unit.show = true
            }else{
              unit.show = false;
            }
            })
          
        });
        
        
      }



      // this.filtrateUnitData(show_floorplan)
    },
    filtrateUnitData(show_floorplan){
      console.log(show_floorplan);
      for (const blockKey in this.BuildingList) {
        let Show_Stacks = []; // 符合条件单元列表下标记录
        const block = this.BuildingList[blockKey];
        block.buildingData.forEach((floor,index) => {
          if(index == 0){
            // 筛选单元下标
            floor.forEach((unit,index1) =>{
              const OrientationIndex = (this.select_data_ck.Orientation == '' || this.OrientationStacks[this.select_data_ck.Orientation].includes(unit.name)) ? index1 : false // 筛选单元
              const ViewIndex = (this.select_data_ck.View == '' || this.ViewStacks[this.select_data_ck.View].includes(unit.name)) ? index1 : false // 筛选单元
              // console.log(OrientationIndex,ViewIndex);
              if(OrientationIndex !== false && ViewIndex !== false){
                // console.log('-----符合单元下标',index1);
                Show_Stacks.push(index1)
              }
            })
            return;
          }
          floor.forEach((unit,index1) => {
              // 判断户型，单元是否符合条件
              if(show_floorplan.includes(unit.name) && Show_Stacks.includes(index1)) {
              unit.show = true
            }else{
              unit.show = false;
            }
            })
          // floor.forEach((unit,index1) => {

            // // 筛选单元列
            // if(index == 0){
            //   const OrientationIndex = (this.select_data_ck.Orientation == 'All' || this.OrientationStacks[this.select_data_ck.Orientation].includes(unit.name)) ? index1 : false // 筛选单元
            //   const ViewIndex = (this.select_data_ck.View == 'All' || this.ViewStacks[this.select_data_ck.View].includes(unit.name)) ? index1 : false // 筛选单元
            //   // console.log(OrientationIndex,ViewIndex);
            //   if(OrientationIndex !== false && ViewIndex !== false){
            //     // console.log('-----符合单元下标',index1);
            //     Show_Stacks.push(index1)
            //   }
            // }
            
            // 不符合条件的单元 直接排除
            // if(!Show_Stacks.includes(index1)) return;
            // if(!Show_Stacks.includes(index1) && unit.type != "Stacks") return;

            // 判断户型是否符合条件
            // if(show_floorplan.includes(unit.name)) unit.show = true;
            
            // 显示tab
            // if (unit.type == "tab" || unit.type == "Stacks") unit.show = true;

             // 默认重置为不显示。
            // if(show_floorplan.includes(unit.name) && Show_Stacks.includes(index1)) {
            //   unit.show = true
            // }else{
            //   unit.show = false;
            // }
          // });
        });
        
        
      }
    },

    // handleSelectChange(){
    //   console.log(this.Price);
    //   for (const blockKey in this.BuildingList) {
    //     const block = this.BuildingList[blockKey];
    //     block.buildingData.forEach((floor) => {
    //       floor.forEach((unit) => {
    //         // 根据条件更新数据，例如：
    //         if (unit.type == "tab") return;
    //         // 条件
    //         // 价格、楼层、朝向、户型 综合条件

    //       });
    //     });
    //   }
    // },
    goUnit(item) {
      console.log(item);
      if (!item) return;
      // this.nowUnit = this.FloorplanData[item]
      this.$router
        .push({
          path: '/Unit',
          query: {
            unit: item,
          },
        })
        .catch((err) => {});
    },
    // clickBuilding(item, i) {
    //   // 切换楼栋
    //   this.buildingName = i;
    //   this.nowBuilding = item;
    // },
    setfloorplan(item){
      // 打开户型浏览
      if(!item) return
      console.log(item);
      // this.buildingName = "BLOCK 60"
      // this.nowBuilding  =  this.BuildingList['BLOCK 60']
      this.showfloorplan = "floorplan"
      this.nowUnit = this.FloorplanData[item]
    },
    SetShowUnit(item,index){
      this.nowUnit = index
    },
    listItemStyle(item) {
      return {
        'background-color': item.color,
        'width': '30px',
        'height': '30px',
        'margin-right': '12px',
      };
    },

  },
  mounted() {
    this.ClearConditions()
    // this.nowBuilding = this.BuildingList["BLOCK 72"];

    // this.handleSelectChange()
  },
};
</script>

<style lang="less">

.clear-min{
  font-weight: 600;
  margin-left: 10px;
  color: brown;
  background-color: white;
  padding: 2px 5px;
  pointer-events: all;
  font-size: 10px;
  border-radius: 10px;
  text-decoration: none !important; 
}


.click-min-btn{
  text-decoration: underline; /* 添加下滑线 */
  position: relative;
  // background-color: #000;
  // color: #fff;
  // border-radius: 5px;
  // padding: 5px;  
  font-size: 1rem !important;
  font-weight: 600;
  // padding-bottom: 5px;
}

// .click-min-btn::before{
//   content: "";
//   position: absolute;
//   width: 50%;
//   height: 2px;
//   background-color: #000;
//   bottom: -5px;
//   margin-bottom: 5px;
// }

// .select-btns{
//   width: 40px;
//   height: 2px;
//   // background-color: black;
//   // border: 1px solid #fff;
//   background-color: black;
//   // border: 1px solid #fff;
//   border-radius: 10px;
// }


.building-tab-bar{
    width: calc(20% - 40px);
    padding: 20px;
    text-align: start;
    height: calc(100% - 40px);
    cursor: pointer;
    .building-btn-group{
      width: 100%;
      border-radius: 5px;
      text-align: start;
      
    }
    .btns{
      margin: 5px 0;
      font-size: 16px;
    }
    .btn-info-line{
      margin-bottom: 2px;
      font-size: 14px;
    }
  }

.SchematicChart {
  overflow: hidden;
  // background-color: #afb2b0 !important;
  .BuildingData {
    width: 100%;
    height: 100%;
    -webkit-overflow-scrolling: touch;
    display: flex;
    justify-content: space-evenly;
  }
  .BuildingShowDiv {
    // position: absolute;
    width: auto;
    height: calc(100% - 2vh);
    // height: 85%;
    margin: 0 20px;
    // margin-bottom: 5vh;
    margin-top: 2vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

  }
}
.mergetr {
  position: relative;
  width: 100%;
}
.mergetd {
  // position: absolute;
  width: calc(100% - 65px) !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  border: 0 !important;
  border-bottom: 1px solid #000000 !important;

  // margin: auto;
}
.table-data {
  border-collapse: collapse;
  border-spacing: 0;
  // border: 1px solid #80808054;
  font-family: QuicksandBook;
  // width: 99%;
  color: #000;
  // margin-top: 3rem;
  // margin-bottom: 2.5rem;
  display: table;
}
.table-tr {
  // border: 1px solid #9E9E9E;
  display: flex;
  flex-direction: row;
  // width: 99%;
}
.td-tab {
  // width: 1.5rem !important;
  // border: 0 !important;
  border: 2px solid #ffffff00 !important;
  // font-weight: 600 !important;
  // font-size: 14px !important;
  // background-color: #000 !important;
}
.td-tab-top{
  // font-weight: 600 !important;
  // font-size: 14px !important;
  border:  1px solid #000000 !important;
  background-color: white !important;
}

.table-td:hover {
  color: #ffffff !important;
  background-color: #616161 !important;
}
.table-td {
  cursor: pointer;
  // border-bottom: 1px solid #000000;
  font-size: 12px;
  // font-weight: 400 !important;
  text-align: center;
  width: 35px;
  // border: 1px solid #9E9E9E;
  border-width: 0 0 0 1px;
  margin: 0;
  overflow: visible;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1rem;
  border-collapse: collapse;
  // background-color: #0000;
  border: 1px solid #000000;
  margin: -1px;
}

.checkedBuildingBtn {
  // color: #2efffa !important;
  color: #000000 !important;
  background-color: white !important;
}

@media screen and (max-height: 500px){
  .SchematicChart .BuildingData{
    height: 100% !important;
  }
}


</style>

